import mixin from './mixin';
import ListItem from './components/ListItem.vue';
import Skeleton from './components/Skeleton.vue';
const axios = require('axios');

const concertGuideApp = {
    mixins: [mixin],
    components: { ListItem, Skeleton },
    data() {
        return {
            tabCount: 0,
            tabs: [],
            lastQuestion: false,
            showQuestions: true,
            answers: [],
            dataLanguageCode: 'nl-NL',
            dataApi: '',
            dataLimit: 10,
            dataSortKey: '',
            dataSortDirection: '',
            dataShowBanners: false,
            loading: false,
            page: 1,
            results: [],
            wishlist: [],
            queryCount: 0,
            loadMore: false
        }
    },
    computed: {
        queryModel() {
            return {
                Limit: this.dataLimit,
                Offset: this.results.length ? (this.page - 1) * this.dataLimit : 0,
                OrderItems: this.orderItems,
                FilterItems: this.answers
            }
        },
        wishlistIds() {
            let result = this.wishlist.map(event => event.id);
            return result;
        }
    },
    methods: {
        async fetchData() {
            try {
                const response = await axios.post(this.dataApi, this.queryModel);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        setTab(index,update = true) {
            this.tabs.map((tab, i) => {
                tab.active = false;
                if (i <= index) tab.disabled = false;
                return tab
            });
            this.tabs[index].active = true;
            if (update) this.updateUrl();
        },
        setQuestion(tabIndex, type, value) {
            let answer = {
                Key: type,
                Values: value,
                Operator: 'Eq'
            };
            if (this.answers[tabIndex] !== undefined) {
                this.answers[tabIndex] = answer;
            } else {
                this.answers.push(answer);
            }
            if (this.answers.length === this.tabCount) {
                this.showQuestions = false;
                this.getResults();
            } else {
                this.setTab(tabIndex + 1);
            }
            this.updateUrl();
        },
        compareArrays(a, b) {
            return JSON.stringify(a) === JSON.stringify(b);
        },
        checkQuestion(tabIndex, type, value) {
            if (this.answers[tabIndex] === undefined) return false;
            return this.answers[tabIndex].Key === type && this.compareArrays(this.answers[tabIndex].Values, value);
        },
        reset() {
            this.tabs.map((tab, index) => {
                if (index === 0) {
                    tab.active = true;
                    tab.disabled = false;
                } else {
                    tab.active = false;
                    tab.disabled = true;
                }
                return tab
            });
            this.answers = [];
            this.results = [];
            this.lastQuestion = false;
            this.showQuestions = true;
            this.updateUrl();
        },
        setData(response) {
            if (!this.loadMore) {
                this.results = response.data.items;
                this.queryCount = response.data.queryCount;
            } else {
                if (response.data.items && response.data.items.length) {
                    response.data.items.forEach(item => {
                        this.results.push(item);
                    })
                }
            }
            this.results = this.results.map(item => {
                return {
                    ...item,
                    favorite: this.wishlistIds.some(wishlistId => wishlistId === item.id),
                }
            });
        },
        async getResults() {
            this.loading = true;
            const resultsResponse = await this.fetchData();
            if (!resultsResponse || resultsResponse.status != 200) return;
            this.setData(resultsResponse);
            this.loading = false;
        },
        async loadmore() {
            this.loadMore = true;
            this.page++;
            const response = await this.fetchData();
            this.setData(response);
            this.updateUrl();
            this.loadMore = false;
        },
        showMonth(index, date) {
            let returnVal = null;
            if (index === 0) {
                returnVal = new Intl.DateTimeFormat(this.dataLanguageCode, { month: 'long' }).format(this.toDateObj(date)) + ' ' + this.toDateObj(date).getFullYear();
            } else {
                let prevEvent = this.results[index - 1];
                if (prevEvent) {
                    if (this.toDateObj(date).getMonth() !== this.toDateObj(prevEvent.startDate).getMonth() || this.toDateObj(date).getYear() !== this.toDateObj(prevEvent.startDate).getYear()) {
                        returnVal = new Intl.DateTimeFormat(this.dataLanguageCode, { month: 'long' }).format(this.toDateObj(date)) + ' ' + this.toDateObj(date).getFullYear();
                    }
                }
            }
            return returnVal;
        },
        updateUrl() {
            if (!this.answers.length) {
                history.pushState({}, null, window.location.pathname);
                return
            }
            const urlParams = new URLSearchParams();
            urlParams.set('activeQuestion', this.tabs.findIndex(tab => tab.active));
            urlParams.set('showResults', !this.showQuestions);
            this.answers.forEach((answer, index) => {
                let answerObj = {};
                answerObj[answer.Key] = answer.Values.join();
                urlParams.append('question-' + index, JSON.stringify(answerObj));
            });
            if (this.page > 1) urlParams.set('page', this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
        },
        bannerTarget(target) {
            if (target) return '_blank';
            return null;
        }
    },
    mounted() {
        this.dataShowBanners = this.$el.hasAttribute('data-showbanners');
        if (this.$el.dataset.language) this.dataLanguageCode = this.$el.dataset.language;
        if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api + '?lang=' + this.dataLanguageCode;
        if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
        if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
        if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
        if (this.$el.dataset.tabcount) this.tabCount = parseInt(this.$el.dataset.tabcount);
        if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api + '?lang=' + this.dataLanguageCode;
        if (this.tabCount) {
            for(let i = 0; i < this.tabCount; i++) {
                this.tabs.push({
                    id: 'tab-'+i,
                    active: i === 0,
                    disabled: i !== 0
                });
            }
        }
        this.wishlist = localStorage.hasOwnProperty('wishlist') ? JSON.parse(localStorage.wishlist) : [];
        let self = this;
        window.addEventListener('wishlist-localstorage-changed', (event) => {
            self.wishlist = JSON.parse(event.detail.storage);
            self.results = self.results.map(item => {
                return {
                    ...item,
                    favorite: self.wishlistIds.some(wishlistId => wishlistId === item.id),
                }
            });
        });
        const urlParams = new URLSearchParams(window.location.search);
        let pageParam = urlParams.has('page') ? parseInt(urlParams.get('page')) : 0;
        if (pageParam) urlParams.delete('page');
        if (pageParam < 2) pageParam = 0;
        if (urlParams.has('activeQuestion')) {
            this.setTab(parseInt(urlParams.get('activeQuestion')),false);
            urlParams.delete('activeQuestion');
        }
        if (urlParams.has('showResults')) {
            this.showQuestions = urlParams.get('showResults') !== 'true';
            urlParams.delete('showResults');
        }
        let tempLimit = this.dataLimit;
        if (pageParam) {
            this.page = pageParam;
            this.dataLimit = this.dataLimit * this.page;
        }
        let answerParams = urlParams.toString() ? urlParams : null;
        if (answerParams) {
            answerParams.forEach((value, key) => {
                let answer = JSON.parse(value);
                this.answers[key.split('-')[1]] = {
                    Key: Object.keys(answer)[0],
                    Values: Object.values(answer)[0].split(','),
                    Operator: 'In'
                };
            });
        }
        if (!this.showQuestions) {
            this.getResults();
            this.dataLimit = tempLimit;
        }
    }
};

export default concertGuideApp;